<script>
export default {
  name: 'ExchangeBidTile',
  props: {
    item: Object,
    isMain: Boolean,
    canBeMain: Boolean,
    editable: Boolean,
  },
};
</script>

<template lang="pug">
  .exchange-bid-tile(:class="{ isMain }")
    .title Предложение
    .main
      Div Наименование {{ item.name }}
      div Артикул: {{ item.vendorCode }}
      div Цвет: {{ item.color }}
      div Объем: {{ item.volume }} {{ item.volumeUnit }}
      div Одна позиция: {{ item.productName }}
      div Цена позиции: {{ item.productPrice }}
      div Кол-во позиций: {{ item.productQty }}
      div Цена доставки: {{ item.deliveryPrice }}
      div Цена монтажа: {{ item.assemblyPrice }}
    .buttons
      Btn(@click="$emit('setMain')" v-if="canBeMain") Сделать основным
      Btn(@click="$emit('unsetMain')" v-if="isMain") Не основной
      Btn(@click="$emit('edit')" v-if="editable") Редактировать
      Btn(@click="$emit('delete')" v-if="editable") Удалить
</template>

<style scoped lang="scss">
 .exchange-bid-tile {
   border: 1px solid #000;
   border-radius: 20px;
   padding: 20px;

   &.isMain {
     border-color: red;
   }
 }

 .title {
   font-size: 20px;
   font-weight: 700;
   margin-bottom: 15px;
 }

 .main {
   display: grid;
   grid-template-columns: 1fr 1fr 1fr;
   align-items: center;
   gap: 10px;
   margin-bottom: 15px;
 }

 .buttons {
   display: flex;
   gap: 20px;
 }
</style>
